import React, { useState, useEffect, useContext } from 'react';
import { Route, Routes, useNavigate, NavLink } from 'react-router-dom';

import TrainerReport from './trainerReports/trainerReports';
import ClassReport from './classReport/classReport';
import AllTransaction from './allTransaction/allTransaction';
import AttendanceReport from './attendanceReport/attendanceReport';

import { FcBusinessman, FcManager, FcPortraitMode, FcAutomotive, FcInternal, FcShipped, FcDonate, FcKindle } from "react-icons/fc";
import { FaUser, FaDumbbell, FaMoneyBillWave } from 'react-icons/fa';

import { DataContext } from '../init/getData';
import { GiWeightLiftingUp  } from 'react-icons/gi';

function ReportTab(props) {

  const { settingData, userData } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role;

  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState('trainerReport');

  useEffect(() => {

    navigate('/reportTab/trainerReport');

  }, []);


  return (
    <div className="card" style={{ paddingTop: '0px', userSelect: 'none' }}>

      <div>

        <NavLink to="trainerReport" onClick={() => setActiveTab('trainerReport')}>
          <div className={`${activeTab === 'trainerReport' ? 'tab-three active-link' : 'tab-three'}`} style={{ width: '12%' }}>
            <GiWeightLiftingUp color='rgb(255, 128, 0)' size={30} />
            <span className="tab-text">Trainer Report</span>
          </div>
        </NavLink>

        <NavLink to="classReport" onClick={() => setActiveTab('classReport')}>
          <div className={`${activeTab === 'classReport' ? 'tab-three active-link' : 'tab-three'}`} style={{ width: '12%' }}>
            <GiWeightLiftingUp color='rgb(255, 128, 0)' size={30} />
            <span className="tab-text">Class Report</span>
          </div>
        </NavLink>

        

        <NavLink to="allTransaction" onClick={() => setActiveTab('allTransaction')}>
          <div className={`${activeTab === 'allTransaction' ? 'tab-three active-link' : 'tab-three'}`} style={{ width: '12%' }}>
            <FaMoneyBillWave color='rgb(255, 128, 0)'  size={30} />
            <span className="tab-text">All Transactions</span>
          </div>
        </NavLink>

        <NavLink to="attendanceReport" onClick={() => setActiveTab('attendanceReport')}>
          <div className={`${activeTab === 'attendanceReport' ? 'tab-four active-link' : 'tab-four'}`} style={{ width: '12%' }}>
            <FaMoneyBillWave color='rgb(255, 128, 0)'  size={30} />
            <span className="tab-text">Attendance</span>
          </div>
        </NavLink>

      </div>


      <Routes>

  
        <Route path='trainerReport' element={<TrainerReport />} />
        <Route path='classReport' element={<ClassReport />} />
        <Route path='allTransaction' element={<AllTransaction />} />
        <Route path='attendanceReport' element={<AttendanceReport />} />

      </Routes>

    </div>
  );
}

export default ReportTab;
